import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

export interface PilotUser {
  timezone?: string;
  pilot_until?: string | null;
  pilot_read_only?: boolean;
  subscription?: { is_active?: boolean } | null;
}

export const PILOT_READ_ONLY_MESSAGE = "Seu período piloto terminou. A clínica está em modo somente leitura. Fale com a CliniSharp para renovar o piloto ou ativar o plano.";

export function pilotWarningStartsAt(until: string | null | undefined, timezone = "America/Sao_Paulo") {
  const end = Date.parse(until ?? "");
  if (!Number.isFinite(end)) return NaN;
  const day = formatInTimeZone(end, timezone, "yyyy-MM-dd");
  const weekBefore = new Date(Date.parse(`${day}T00:00:00Z`) - 7 * 86400000).toISOString().slice(0, 10);
  return fromZonedTime(`${weekBefore}T00:00:00`, timezone).getTime();
}

export function pilotAccess(user: PilotUser | null | undefined, now = Date.now()) {
  const until = user?.pilot_until ?? null;
  const end = until ? Date.parse(until) : NaN;
  const hasPilot = Number.isFinite(end);
  const paid = user?.subscription?.is_active === true;
  return {
    until,
    timezone: user?.timezone ?? "America/Sao_Paulo",
    hasPilot,
    active: hasPilot && end >= now,
    readOnly: user?.pilot_read_only === true || (!paid && hasPilot && end < now),
    warning: !paid && hasPilot && end > now && now >= pilotWarningStartsAt(until, user?.timezone),
  };
}

export function pilotResponseAction(
  status: number | undefined,
  body: { code?: string; message?: string; data?: { subscription_status?: string } } | undefined,
  user: PilotUser | null | undefined,
  now = Date.now(),
): "stay" | "billing" | "suspended" | "read-only" {
  if (status === 403 && body?.code === "pilot_read_only") return "read-only";
  if (status !== 402) return "stay";
  if (body?.data?.subscription_status === "SUSPENDED") return "suspended";
  return pilotAccess(user, now).hasPilot || user?.pilot_read_only ? "stay" : "billing";
}
